import type { FullnameParams } from '@restore/dynamic-forms';
import { DocumentServiceFullname } from './types';
import { convertBoolean } from './convertBoolean';

export const fullName = (
  fullnameProperties: DocumentServiceFullname | undefined
): FullnameParams | undefined => {
  if (!fullnameProperties) {
    return undefined;
  }

  const parsed: FullnameParams = {
    ...fullnameProperties,
    prefix: {
      ...fullnameProperties.prefix,
      enabled: convertBoolean(fullnameProperties.prefix.enabled),
    },
    middleName: {
      ...fullnameProperties.middleName,
      enabled: convertBoolean(fullnameProperties.middleName.enabled),
    },
    suffix: {
      ...fullnameProperties.suffix,
      enabled: convertBoolean(fullnameProperties.suffix.enabled),
    },
  };

  return parsed;
};
